<mode-file-exports-ui-drawer
	[drawerContext]="drawerContext"
	[expanded]="expanded$ | async"
	[visible]="visible$ | async"
	[downloads]="downloads$ | async"
	(expandDrawer)="onExpandDrawer()"
	(closeDrawer)="onCloseDrawer()"
	(downloadCsv)="onDownloadCsv($event)"
	(retryDownloadCsv)="onRetryDownloadCsv($event)"
	(deleteCsv)="onDeleteCsv($event)"
></mode-file-exports-ui-drawer>
